import {API_RESOURCES, createApiReadAction} from '../../util/api';
import * as types from '../actiontypes';
import { deleteDocumentById as _deleteDocumentById } from '../../actions/Document/documentactions';

export const getEstimates = (engagementId, queryString) => {
	return createApiReadAction(
		types.GET_ESTIMATES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ESTIMATE]: null
		},
		queryString
	);
};

export const getEstimateById = (engagementId, estimateId, queryString) => {
	return createApiReadAction(
		types.GET_ESTIMATE_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ESTIMATE]: estimateId
		},
		queryString
	);
};

export const deleteDocumentById = (
	engagementId,
	documentId,
	entityUId,
	viewKey,
	action = 'delete',
	parentName,
	sectionId
) => {
	return _deleteDocumentById(
		engagementId,
		documentId,
		entityUId,
		viewKey,
		action = 'delete',
		parentName,
		null,
		sectionId,
		types.DELETE_ESTIMATE_DOCUMENT_BY_ID
	)
}